// extracted by mini-css-extract-plugin
export default {"starsContainer":"RatingStars_starsContainer__vmWKk","star":"RatingStars_star__95wO8"};